import React from 'react';
import PropTypes from 'prop-types';
import { StyledCurrencyText } from './components/CurrencyDisplayStyles';
import { useCurrencyDisplay } from './hooks/useCurrencyDisplay';

const CurrencyDisplay = ({ value, style, className, ...props }) => {
  const { formattedValue } = useCurrencyDisplay({ value });

  return (
    <StyledCurrencyText className={className} style={style} {...props}>
      {formattedValue}
    </StyledCurrencyText>
  );
};

CurrencyDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
};

CurrencyDisplay.defaultProps = {
  style: {},
  className: '',
};

export default CurrencyDisplay;



// WEBPACK FOOTER //
// ./src/design-system/atoms/CurrencyDisplay/CurrencyDisplay.jsx